import { FC, useState, useEffect } from 'react';
import { DynamicDetail } from '@/common/components/business/StoreDetail';
import V2Empty from '@/common/components/Data/V2Empty';
import { isArray, isNotEmptyAny } from '@lhb/func';

/**
 * 拓店任务-详情-加盟商tab-动态表单字段展示
 * @Description
 * 拓店任务：加盟（益禾堂、非益禾堂）
 */
const FranchiseeInfo: FC<{
  /** 加盟商详情 */
  franDetail: any;
}> = ({
  franDetail,
}) => {
  const [dynamicInfo, setDynamicInfo] = useState<any>({});

  useEffect(() => {
    if (!isNotEmptyAny(franDetail)) {
      setDynamicInfo({});
      return;
    }

    const { propertyGroupVOList } = franDetail;
    if (!isArray(propertyGroupVOList) || !propertyGroupVOList.length) {
      setDynamicInfo({});
      return;
    }

    setDynamicInfo({
      templateDetailResponse: {
        propertyGroupVOList,
      }
    });
  }, [franDetail]);

  return (
    <>
      { isNotEmptyAny(dynamicInfo) ? <DynamicDetail
        title=''
        ignoreAttach // 不需要显示【附加资料】
        isTopSticky
        data={dynamicInfo}
      /> : <V2Empty className='mt-100'/>}
    </>
  );
};

export default FranchiseeInfo;
